import { SortOrder } from '../../Utils/Constants';
export const GET_SESSION_QUESTIONS_REQUEST = 'GET_SESSION_QUESTIONS_REQUEST';
export const GET_SESSION_QUESTIONS_SUCCESS = 'GET_SESSION_QUESTIONS_SUCCESS';
export const GET_SESSION_QUESTIONS_FAILURE = 'GET_SESSION_QUESTIONS_FAILURE';

export function getSessionQuestions(
  sessionKey,
  pageNumber = 0,
  size = 50,
  filter = { textSearch: '', answered: null, dateAskedSortOrder: SortOrder.DESC }
) {
  return {
    type: GET_SESSION_QUESTIONS_REQUEST,
    payload: { sessionKey, pageNumber, size, filter }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/SessionQuestions/SessionQuestionsActions.js